// Arabic identity strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enIdentity } from './en-identity.ts';
import type { Message } from './types.ts';

export const arIdentity: { readonly [K in keyof typeof enIdentity]: Message } = {
  'api.ssoFailed': 'تعذّر إكمال تسجيل الدخول الموحّد. حاول مرة أخرى، أو سجّل الدخول بكلمة مرور Passage.',
  'api.ssoNotLinked': 'حساب مؤسستك غير مرتبط بـ Passage بعد. اطلب الوصول من مسؤول Passage.',
  'api.ssoUnavailable': 'لا يمكن الوصول إلى مزوّد الهوية هذا بإعداداته الحالية.',
  'api.providerNotTestable': 'يحتاج مزوّد الهوية هذا إلى إعداد مكتمل، ويجب ألا يكون معطّلًا، قبل اختباره.',
  'api.providerTestRequired': 'أجرِ تسجيل دخول تجريبيًا ناجحًا بالإعدادات الحالية قبل تفعيل هذا المزوّد.',
  'api.identityLinkExists': 'هذه الهوية الخارجية مرتبطة مسبقًا، أو أن لدى المستخدم ربطًا مع هذا المزوّد.',
  'api.identityLinkRevoked': 'تمت إزالة هذا الربط مسبقًا.',

  'v.url': 'أدخل عنوانًا كاملًا، مثل https://login.example.com.',
  'v.httpsRequired': 'استخدم عنوانًا يبدأ بـ https://.',
  'v.claimName': 'استخدم اسم مطالبة أو سمة من أحرف وأرقام و : . / # _ - فقط.',
  'v.entraTenant': 'أدخل معرّف مستأجر Microsoft Entra (بصيغة GUID).',
  'v.certificate': 'الصق شهادة أو مفتاحًا عامًا بصيغة PEM.',
  'v.mappingElevated': 'لا يمكن ربط أدوار المسؤول أو الأدوار المتخصصة أو القدرات الحساسة إلا مع تحديد «السماح بوصول مرتفع».',
  'v.secretShort': 'استخدم 8 أحرف على الأقل.',
  'v.secretRef': 'استخدم اسم السر بأحرف كبيرة وأرقام وشرطات سفلية (مثل LDAP_BIND_PASSWORD).',
  'v.ldapsUrl': 'استخدم عنوانًا يبدأ بـ ldaps:// (‏LDAP عبر TLS).',
  'v.simulatorProduction': 'محاكي الدليل متاح في بيئة التطوير فقط.',
  'v.json': 'أدخل JSON صالحًا.',

  'identity.tab': 'مزوّدو الهوية',
  'roles.tab': 'معاينة الأدوار',
  'identity.sub': 'تسجيل الدخول الموحّد والتزويد ومزامنة الدليل لمؤسستك.',
  'identity.panel': 'تسجيل الدخول الموحّد والتزويد',
  'identity.panelSub': 'يثبت تسجيل الدخول هوية الشخص؛ أما ما يُسمح له به فيأتي فقط من صلاحيات Passage.',
  'identity.simulatorNote': 'لم تُختبر حتى الآن سوى المحاكيات المحلية. لم يُثبت بعد التشغيل البيني مع مزوّدي هوية وأدلة حقيقية.',
  'identity.entitlementMissing': 'لا تتضمن خطة مؤسستك هذه القدرة. تبقى الإعدادات الحالية ظاهرة ويمكن تعطيلها.',
  'identity.loading': 'جارٍ تحميل إعدادات الهوية…',

  'identity.providers': 'مزوّدو الهوية',
  'identity.providersSub': 'Microsoft Entra ID ومزوّدو OpenID Connect الآخرون و SAML 2.0.',
  'identity.providers.none': 'لم يُعدّ أي مزوّد هوية. يسجّل الأشخاص الدخول بكلمة مرور Passage.',
  'identity.providers.add': 'إضافة مزوّد هوية',
  'identity.col.provider': 'المزوّد',
  'identity.col.protocol': 'البروتوكول',
  'identity.col.status': 'الحالة',
  'identity.col.tested': 'الاختبار',
  'identity.col.linked': 'الأشخاص المرتبطون',
  'identity.col.action': 'الإجراء',
  'identity.open': 'فتح',
  'identity.openLabel': 'فتح {name}',
  'identity.tested.yes': 'تم اختبار الإعدادات الحالية',
  'identity.tested.no': 'لم يُختبر منذ آخر تغيير',
  'identity.protocol.oidc': 'OpenID Connect',
  'identity.protocol.saml': 'SAML 2.0',
  'identity.preset.entra': 'Microsoft Entra ID',
  'identity.preset.generic': 'قائم على المعايير',
  'status.draft': 'مسودة',
  'status.held': 'معلّق للمراجعة',

  'identity.add.title': 'إضافة مزوّد هوية',
  'identity.add.sub': 'يبدأ المزوّد كمسودة. اختبره قبل تفعيله.',
  'identity.add.kind': 'نوع المزوّد',
  'identity.kind.entra-oidc': 'Microsoft Entra ID (‏OpenID Connect)',
  'identity.kind.oidc': 'مزوّد OpenID Connect آخر',
  'identity.kind.saml': 'مزوّد SAML 2.0',
  'identity.kind.entra-saml': 'Microsoft Entra ID (‏SAML)',
  'identity.f.displayName': 'الاسم المعروض في صفحة تسجيل الدخول',
  'identity.f.tenantIds': 'معرّفات مستأجري Microsoft Entra المعتمدة',
  'identity.f.tenantIdsHint': 'يُرفض تسجيل الدخول من أي مستأجر آخر. افصل بين المعرّفات بفواصل.',
  'identity.f.issuer': 'جهة الإصدار',
  'identity.f.authorizationEndpoint': 'نقطة التفويض',
  'identity.f.tokenEndpoint': 'نقطة الرموز',
  'identity.f.jwksUri': 'عنوان مفاتيح التوقيع (JWKS)',
  'identity.f.clientId': 'معرّف العميل (التطبيق)',
  'identity.f.clientSecret': 'سر العميل',
  'identity.f.clientSecretHint': 'يُخزَّن مشفّرًا ولا يُعرض مرة أخرى. يُسجَّل التدوير برقم الإصدار فقط.',
  'identity.f.groupsClaim': 'مطالبة المجموعات',
  'identity.f.idpEntityId': 'معرّف كيان مزوّد الهوية',
  'identity.f.ssoUrl': 'عنوان تسجيل الدخول الموحّد',
  'identity.f.certificate': 'شهادة التوقيع (PEM)',
  'identity.f.certificateHint': 'الصق شهادة التوقيع أو المفتاح العام لمزوّد الهوية.',
  'identity.f.linkByEmail': 'السماح لمستخدمي Passage الحاليين بربط حساباتهم بتأكيد كلمة مرور Passage مرة واحدة',
  'identity.f.trustIdpMfa': 'قبول المصادقة متعددة العوامل لدى مزوّد الهوية بدلًا من عامل Passage',
  'identity.f.linkProvisioned': 'الربط تلقائيًا عندما يطابق المعرّف الخارجي المزوَّد الموضوعَ المتحقَّق منه',
  'identity.f.jit': 'إنشاء الحسابات عند أول تسجيل دخول (لا يُمنح أي وصول إلا بقواعد الربط)',
  'identity.f.jitDomains': 'نطاقات البريد المسموح بها للحسابات التلقائية',
  'identity.create': 'إنشاء مسودة',

  'identity.detail.eyebrow': 'Passage / المستخدمون والصلاحيات / مزوّدو الهوية',
  'identity.detail.back': 'العودة إلى مزوّدي الهوية',
  'identity.detail.facts': 'المزوّد',
  'identity.detail.version': 'إصدار الإعداد',
  'identity.detail.secret': 'سر العميل',
  'identity.detail.secretSet': 'مُعَدّ (الإصدار {version})',
  'identity.detail.secretNone': 'غير مُعَدّ',
  'identity.detail.register': 'سجّل Passage لدى مزوّد الهوية',
  'identity.detail.registerSub': 'انسخ هذه القيم إلى إعدادات التطبيق لدى المزوّد.',
  'identity.detail.entityId': 'معرّف الكيان (الجمهور)',
  'identity.detail.acsUrl': 'عنوان الرد / مستهلك التأكيدات',
  'identity.detail.redirectUri': 'عنوان إعادة التوجيه',
  'identity.detail.metadataUrl': 'بيانات تعريف مزوّد الخدمة',
  'identity.detail.certificates': 'شهادات التوقيع الموثوقة',
  'identity.detail.certificatesSub': 'أضف الشهادة الجديدة قبل أن يدوّر مزوّدك مفاتيحه، ثم أزل القديمة.',
  'identity.detail.fingerprint': 'بصمة SHA-256',
  'identity.detail.validTo': 'صالحة حتى',
  'identity.detail.publicKey': 'مفتاح عام',
  'identity.detail.addCertificate': 'إضافة شهادة',
  'identity.detail.removeCertificate': 'إزالة',
  'identity.detail.removeCertificateLabel': 'إزالة الشهادة {fingerprint}',
  'identity.detail.test': 'تسجيل دخول تجريبي',
  'identity.detail.testHint': 'يسجّل الدخول لدى المزوّد دون إنشاء جلسة Passage، ويعرض ما سيحدث في تسجيل دخول فعلي.',
  'identity.detail.activate': 'تفعيل',
  'identity.detail.activateSub': 'سيرى الأشخاص هذا المزوّد في صفحة تسجيل الدخول.',
  'identity.detail.disable': 'تعطيل',
  'identity.detail.disableSub': 'يتوقف تسجيل الدخول عبر هذا المزوّد وتنتهي الجلسات التي بدأت به الآن.',
  'identity.detail.rotate': 'تدوير سر العميل',
  'identity.detail.rotateSub': 'يُستخدم السر الجديد من تسجيل الدخول التالي. يسجّل التدقيق رقم الإصدار فقط.',
  'identity.detail.lastTest': 'آخر اختبار',
  'identity.detail.never': 'أبدًا',

  'mapping.title': 'ربط المطالبات',
  'mapping.sub': 'امنح وصول Passage من المطالبات التي يرسلها المزوّد. يُطبَّق عند كل تسجيل دخول، وينتهي الوصول عندما لا تعود المطالبة مطابقة.',
  'mapping.scimTitle': 'ربط المجموعات',
  'mapping.scimSub': 'امنح وصول Passage من عضوية مجموعات SCIM. يُطبَّق فورًا ويُزال عند انتهاء العضوية.',
  'mapping.none': 'لا توجد قواعد ربط. يأتي الوصول فقط من الصلاحيات الممنوحة في Passage.',
  'mapping.add': 'إضافة قاعدة ربط',
  'mapping.col.when': 'عندما',
  'mapping.col.grant': 'يمنح',
  'mapping.col.conferred': 'الأشخاص',
  'mapping.when': '{claim} = {value}',
  'mapping.whenGroup': 'عضو في {group}',
  'mapping.f.claim': 'المطالبة أو السمة',
  'mapping.f.value': 'القيمة',
  'mapping.f.group': 'مجموعة SCIM',
  'mapping.f.kind': 'نوع الصلاحية',
  'mapping.kind.experience': 'دور',
  'mapping.kind.specialist': 'دور متخصص',
  'mapping.f.code': 'الدور',
  'mapping.f.site': 'الموقع',
  'mapping.f.elevated': 'السماح بوصول مرتفع (أدوار المسؤول أو الأدوار المتخصصة)',
  'mapping.f.elevatedHint': 'لا يمكن حفظ ذلك إلا لمن يحق له منح الصلاحيات الحساسة. يُفضَّل منح هذه الأدوار فرديًا.',
  'mapping.elevatedBadge': 'مرتفع',
  'mapping.disable': 'تعطيل',
  'mapping.disableSub': 'تُلغى الآن الصلاحيات التي لا تبررها إلا هذه القاعدة.',

  'test.title': 'نتيجة تسجيل الدخول التجريبي',
  'test.loading': 'جارٍ التحقق من تسجيل الدخول التجريبي…',
  'test.invalid': 'نتيجة الاختبار هذه غير متاحة. ابدأ اختبارًا جديدًا من صفحة المزوّد.',
  'test.outcome': 'النتيجة',
  'test.reason': 'السبب',
  'test.subject': 'الموضوع المتحقَّق منه',
  'test.email': 'البريد الإلكتروني',
  'test.emailVerified': 'البريد الإلكتروني متحقَّق منه',
  'test.groups': 'المجموعات',
  'test.idpMfa': 'أكّد المزوّد المصادقة متعددة العوامل',
  'test.wouldResolve': 'في تسجيل دخول فعلي سيتم',
  'test.resolve.linked_user': 'تسجيل دخول حساب Passage المرتبط',
  'test.resolve.link_with_password': 'مطالبة مستخدم Passage المطابق بتأكيد كلمة مروره مرة واحدة ثم الربط',
  'test.resolve.provisioned_subject': 'ربط الحساب المزوَّد بهذا المعرّف الخارجي',
  'test.resolve.jit_create': 'إنشاء حساب جديد (فوري)',
  'test.resolve.no_account': 'الرفض: لا يوجد حساب Passage مرتبط',
  'test.matchedUser': 'حساب Passage',
  'test.grants': 'الوصول من قواعد الربط',
  'test.noGrants': 'لا شيء',
  'test.backToProvider': 'العودة إلى المزوّد',
  'test.reason.state_invalid': 'لم يُتعرّف على طلب تسجيل الدخول أو سبق استخدامه.',
  'test.reason.request_expired': 'انتهت صلاحية الطلب أو تغيّرت إعدادات المزوّد أثناء الاختبار.',
  'test.reason.signature_invalid': 'تعذّر التحقق من التوقيع بالمفاتيح الموثوقة.',
  'test.reason.unsigned': 'لم تكن الاستجابة موقّعة.',
  'test.reason.issuer_mismatch': 'جاءت الاستجابة من جهة إصدار مختلفة.',
  'test.reason.audience_mismatch': 'كانت الاستجابة موجّهة إلى تطبيق مختلف.',
  'test.reason.recipient_mismatch': 'كانت الاستجابة موجّهة إلى عنوان رد مختلف.',
  'test.reason.expired': 'انتهت صلاحية الاستجابة.',
  'test.reason.not_yet_valid': 'الاستجابة غير صالحة بعد (تحقق من الساعات).',
  'test.reason.tenant_not_allowed': 'مستأجر Microsoft Entra ليس ضمن القائمة المعتمدة.',
  'test.reason.replayed': 'سبق استخدام هذه الاستجابة.',
  'test.reason.token_exchange_failed': 'رفضت نقطة الرموز الطلب (تحقق من معرّف العميل وسره).',
  'test.reason.provider_unavailable': 'تعذّر الوصول إلى المزوّد.',
  'test.reason.other': 'رُفضت الاستجابة ({reason}).',

  'scim.title': 'التزويد عبر SCIM',
  'scim.sub': 'ينشئ مزوّد الهوية حسابات Passage ويحدّثها ويعطّلها. لا تُحذف الحسابات أبدًا.',
  'scim.baseUrl': 'عنوان SCIM الأساسي',
  'scim.provisioned': 'الحسابات التي يديرها SCIM',
  'scim.tokens': 'رموز الوصول',
  'scim.tokens.none': 'لم تُصدر أي رموز.',
  'scim.token.issue': 'إصدار رمز',
  'scim.token.issueSub': 'يُعرض الرمز مرة واحدة. احفظه في إعدادات التزويد لدى مزوّد الهوية.',
  'scim.token.label': 'التسمية',
  'scim.token.expires': 'صالح لمدة (أيام)',
  'scim.token.hint': 'ينتهي بـ',
  'scim.token.lastUsed': 'آخر استخدام',
  'scim.token.revoke': 'إلغاء',
  'scim.token.revokeSub': 'يتوقف التزويد بهذا الرمز فورًا.',
  'scim.token.issued': 'تم إصدار الرمز',
  'scim.token.issuedBody': 'انسخه الآن. يحتفظ Passage ببصمة فقط ولا يمكنه عرضه مرة أخرى.',
  'scim.groups': 'المجموعات المزوَّدة',
  'scim.groups.none': 'لم تُزوَّد أي مجموعات بعد.',
  'scim.groupMembers': { zero: 'لا أعضاء', one: 'عضو واحد', two: 'عضوان', few: '{count} أعضاء', many: '{count} عضوًا', other: '{count} عضو' },

  'directory.title': 'مزامنة الدليل',
  'directory.sub': 'مزامنة للقراءة فقط من LDAP / Active Directory. إذا تعذّر الوصول إلى الدليل فلا يتغير شيء وتبقى آخر حالة معروفة.',
  'directory.none': 'لا يوجد اتصال بدليل.',
  'directory.add': 'إضافة دليل',
  'directory.kind.simulator': 'محاكي الدليل (للتطوير فقط)',
  'directory.kind.ldap': 'LDAP / Active Directory',
  'directory.f.secretRef': 'اسم سر بيانات اعتماد الربط',
  'directory.f.secretRefHint': 'اسم سر النشر الذي يحمل كلمة المرور — وليس كلمة المرور نفسها أبدًا.',
  'directory.f.entries': 'إدخالات الدليل التجريبية (JSON)',
  'directory.f.schedule': 'المزامنة كل (دقيقة)',
  'directory.f.maxDeactivation': 'التعليق للمراجعة إذا كان سيُعطَّل أكثر من هذه النسبة % من الحسابات',
  'directory.lastRun': 'آخر تشغيل',
  'directory.lastSuccess': 'آخر قراءة ناجحة',
  'directory.owned': 'الحسابات المملوكة',
  'directory.stale': 'قديمة: لم تتم قراءة الدليل بنجاح مؤخرًا. تحتفظ الحسابات بآخر حالة معروفة.',
  'directory.sync': 'مزامنة الآن',
  'directory.syncSub': 'يقرأ الدليل ويطبّق التغييرات على الحسابات التي يملكها.',
  'directory.confirm': 'تطبيق التعطيلات المعلّقة',
  'directory.confirmSub': 'عُلّق التشغيل الأخير لأنه كان سيعطّل حسابات كثيرة. راجع الدليل قبل التطبيق.',
  'directory.run.result': 'أُنشئ {created} · حُدّث {updated} · عُطّل {deactivated} · أُعيد تفعيل {reactivated} · دون تغيير {unchanged} · تعارضات {conflicts}',
  'directory.error.unreachable': 'تعذّر الوصول إلى الدليل',
  'directory.error.adapter_not_available': 'محوّل LDAP غير متاح بعد',
  'directory.error.credential_missing': 'بيانات اعتماد الربط غير مضبوطة أو غير موجودة أو يتعذّر فتحها',
  'directory.error.invalid_response': 'استجابة غير متوقعة من الدليل',
  'directory.conflict.email_in_use': 'البريد الإلكتروني مستخدم لحساب آخر',
  'directory.conflict.duplicate_external_id': 'معرّف خارجي مكرر في الدليل',
  'directory.conflict.invalid_entry': 'إدخال دليل غير صالح',
  'directory.conflict.deactivation_threshold': 'تعطيلات معلّقة للمراجعة',
  'directory.conflict.last_administrator': 'سيزيل آخر مسؤول',
  'directory.conflict.administrator_hold': 'عطّله مسؤول في Passage',

  'links.title': 'هويات تسجيل الدخول',
  'links.sub': 'الهويات الخارجية التي يمكنها تسجيل الدخول باسم هذا الشخص، والمصدر الذي يزوّد الحساب.',
  'links.none': 'لا توجد هوية خارجية مرتبطة.',
  'links.provider': 'المزوّد',
  'links.subject': 'الموضوع',
  'links.via': 'رُبط عبر',
  'links.via.local_proof': 'تأكيد كلمة المرور',
  'links.via.administrator': 'المسؤول',
  'links.via.provisioned_subject': 'المعرّف الخارجي المزوَّد',
  'links.via.jit': 'حساب تلقائي',
  'links.source': 'زوّده',
  'links.source.none': 'Passage (يُدار هنا)',
  'links.source.scim': 'SCIM',
  'links.source.directory': 'الدليل',
  'links.source.sso_jit': 'تسجيل الدخول الموحّد (حساب تلقائي)',
  'links.add': 'ربط هوية',
  'links.addSub': 'أدخل الموضوع الثابت الذي يستخدمه مزوّدك لهذا الشخص (لـ Microsoft Entra ID: معرّف المستأجر/معرّف الكائن).',
  'links.revoke': 'إلغاء الربط',
  'links.revokeSub': 'يتوقف تسجيل الدخول بهذه الهوية وتنتهي الجلسات التي بدأت بها الآن.',

  'auth.ssoWith': 'المتابعة باستخدام {name}',
  'auth.ssoRedirecting': 'جارٍ فتح تسجيل الدخول الخاص بمؤسستك…',
  'sso.title': 'تسجيل الدخول الموحّد',
  'sso.checking': 'جارٍ إكمال تسجيل الدخول…',
  'sso.failed': 'تعذّر إكمال تسجيل الدخول الموحّد. حاول مرة أخرى، أو سجّل الدخول بكلمة مرور Passage.',
  'sso.link.title': 'اربط حساب Passage الخاص بك',
  'sso.link.lede': 'سجّلك {provider} بالحساب {email}. أكّد كلمة مرور Passage مرة واحدة لربط تسجيل الدخول هذا بحسابك.',
  'sso.link.submit': 'تأكيد وربط',
  'sso.back': 'العودة إلى تسجيل الدخول',

  'roles.title': 'معاينة الأدوار',
  'roles.sub': 'ما يمكن لكل دور فعله، مولَّدًا من كتالوج التفويض في الخادم. كل ما لم يُذكر مرفوض.',
  'roles.loading': 'جارٍ تحميل كتالوج الأدوار…',
  'roles.col.action': 'الإجراء',
  'roles.col.scope': 'النطاق',
  'roles.scope.tenant': 'المؤسسة',
  'roles.scope.site': 'الموقع',
  'roles.sensitive': 'حساس — دور متخصص فقط',
  'roles.entitlement': 'يتطلب {entitlement}',
  'roles.tableLabel': 'مصفوفة الأدوار والإجراءات',
  'roles.specialists': 'الأدوار المتخصصة',
  'roles.yes': 'مشمول',

  'platform.identity.title': 'اتحاد الهوية',
  'platform.identity.sub': 'ملخص للقراءة فقط. يُعدّ مسؤولو المؤسسة المزوّدين؛ ويمكنك تعطيل أحدها في حالة طارئة.',
  'platform.identity.providers': 'مزوّدو الهوية',
  'platform.identity.none': 'لا يوجد مزوّدو هوية.',
  'platform.identity.tokens': 'رموز SCIM',
  'platform.identity.directories': 'اتصالات الدليل',
  'platform.identity.elevated': 'قواعد الربط المرتفعة النشطة',
  'platform.identity.provisioned': 'الحسابات المزوَّدة: SCIM {scim} · الدليل {directory} · تلقائي {jit}',
  'platform.identity.disable': 'تعطيل طارئ',
};
